'use strict';

window.BASE_URL = '//www.nextstudios.com/';
window.BASE_MOBILE_ROOT = window.BASE_URL + 'm/';
window.COMPANY_NAME = "NExT STUDIOS";
window.COMPANY_NAME_LC = "NExT Studios"; //lowercase

window.TCSS_VIRTUAL_DOMAIL = "thenextstudio.qq.com";
window.SITE_MAILS = {
  'index': 'contact@nextstudios.com'
};
window.BASE_SUBURLS = {
  'cn_index': window.BASE_URL + 'm/' + 'm_index.html',
  'cn_news': window.BASE_URL + 'm/' + 'cn/news/index.html',
  'cn_newsdetail': window.BASE_URL + 'm/' + 'cn/news/newsdetail.html',
  'cn_career': window.BASE_URL + 'm/' + 'cn/career/index.html',
  'en_index': window.BASE_URL + 'm/' + 'index_en.html',
  'en_news': window.BASE_URL + 'm/' + 'en/news/index.html',
  'en_newsdetail': window.BASE_URL + 'm/' + 'en/news/newsdetail.html',
  'en_career': window.BASE_URL + 'm/' + 'en/career/index.html',
  //以下是正式用的
  'cn': {
    'index': window.BASE_URL + 'm/' + 'm_index.html',
    'news': window.BASE_URL + 'm/' + 'cn/news/index.html',
    'newsdetail': window.BASE_URL + 'm/' + 'cn/news/newsdetail.html',
    'career': window.BASE_URL + 'm/' + 'cn/about/commonindex.html' + '#/career',
    'next': window.BASE_URL + 'm/' + 'cn/about/commonindex.html' + '#/next',
    'tech': {
      'siren': window.BASE_URL + 'm/' + 'cn/tech/siren.html',
      'techlabs': window.BASE_URL + 'm/' + 'cn/tech/techlabs.html'
    },
    'support': window.BASE_URL + 'm/' + 'cn/support/index.html',
    'games': window.BASE_URL + 'm/' + 'cn/games/index.html',
    'playgroundgames': window.BASE_URL + 'm/' + 'cn/games/playground.html',
    'bloglist': window.BASE_URL + 'm/' + 'cn/blog/bloglist.html',
    'blogdetail': window.BASE_URL + 'm/' + 'cn/blog/blogdetail.html'
  },
  'en': {
    'index': window.BASE_URL + 'm/' + 'index_en.html',
    'news': window.BASE_URL + 'm/' + 'en/news/index.html',
    'newsdetail': window.BASE_URL + 'm/' + 'en/news/newsdetail.html',
    'career': window.BASE_URL + 'm/' + 'en/about/commonindex.html' + '#/career',
    'next': window.BASE_URL + 'm/' + 'en/about/commonindex.html' + '#/next',
    'tech': {
      'siren': window.BASE_URL + 'm/' + 'en/tech/siren.html',
      'techlabs': window.BASE_URL + 'm/' + 'en/tech/techlabs.html'
    },
    'support': window.BASE_URL + 'm/' + 'en/support/index.html',
    'games': window.BASE_URL + 'm/' + 'en/games/index.html',
    'playgroundgames': window.BASE_URL + 'm/' + 'en/games/playground.html',
    'bloglist': window.BASE_URL + 'm/' + 'en/blog/bloglist.html',
    'blogdetail': window.BASE_URL + 'm/' + 'en/blog/blogdetail.html'
  }
};
window.PAGE_DATA = {
  imgBase: '//ossweb-img.qq.com/upload/adw/',
  newsBase: '//www.nextstudios.com/',
  isloadtcss: true
};